import { Information } from '@carbon/icons-react';
import { Button, Tooltip } from '@ph-react-ui/core';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

export interface ResendButtonProps {
  isDirty: boolean;
  isEmpty: boolean;
  isSubmitting: boolean;
  /** True while this row’s resend request is in flight (spinner on this button only). */
  isResendLoading: boolean;
  /** True while any resend is in flight (all resend buttons disabled). */
  isResendBusy: boolean;
  onClick: () => void;
  tooltipMessage: string;
  buttonText: string;
  lastSentDate?: string | null;
}
export function ResendButton({
  isDirty,
  isEmpty,
  isSubmitting,
  isResendLoading,
  isResendBusy,
  onClick,
  tooltipMessage,
  buttonText,
  lastSentDate,
}: ResendButtonProps) {
  const { t } = useTranslation();

  const formatDate = (dateString?: string | null) => {
    if (!dateString || dateString.startsWith('0001-01-01')) {
      return '-';
    }

    try {
      const date = new Date(dateString);
      return isNaN(date.getTime()) ? '-' : format(date, 'dd.MM.yyyy HH:mm');
    } catch {
      return '-';
    }
  };

  const button = (
    <Button
      type="button"
      className="settings__actions__button notification-row__button"
      loading={isResendLoading}
      disabled={isDirty || isEmpty || isSubmitting || isResendBusy}
      onClick={onClick}
    >
      {buttonText}
    </Button>
  );

  return (
    <div className="notification-row__resend">
      <span className="notification-row__last-sent">
        <Information size={16} className="notification-row__last-sent-icon" />
        {t('SETTINGS.LABELS.EMAIL_LAST_SENT')}: {formatDate(lastSentDate)}
      </span>
      {isDirty ? (
        <Tooltip position="bottom" message={tooltipMessage}>
          {button}
        </Tooltip>
      ) : (
        button
      )}
    </div>
  );
}
